<template>
  <BaseBoxColor variant="gray" class="h-full w-full space-y-4 p-4">
    <div class="flex justify-between">
      <h3>{{ name }}</h3>
      <div>
        <BaseButton
          :outline="true"
          v-if="user.role_id == 2"
          size="xs"
          @click="handleManageOrganization(organization)"
          >{{ $t("manage") }}</BaseButton
        >
        <BaseButton
          :outline="true"
          size="xs"
          class="ml-2"
          @click="handleOverviewOrganization(organization)"
          >{{ $t("overview") }}</BaseButton
        >
        </div>
    </div>
    <ul class="space-y-2">
      <li>
        <h4 class="text-sm uppercase text-white/75">
          {{ $t("scopeBase") }}
        </h4>
        <strong>{{ scopebase }}</strong>
      </li>
      <li v-if="activeScopes.length">
        <h4 class="text-sm uppercase text-white/75 mb-1">
          {{ $t("activeScope") }}
        </h4>
          <BaseBadge v-for="scope in activeScopes" class="bg-opacity-70 mr-2">
            {{ scope.slug }}
          </BaseBadge>
      </li>
      <li v-if="debugScopes.length">
        <h4 class="text-sm uppercase text-white/75 mb-1">
          {{ $t("debugScope") }}
        </h4>
        <BaseBadge v-for="scope in debugScopes" class="bg-opacity-70 mr-2" variant="bordered">
          {{ scope.slug }}
        </BaseBadge>
      </li>
    </ul>
    <div class="flex gap-x-6">
      <!-- <div v-if="totAdmin">
        <h4 class="text-sm uppercase text-white/75">
          {{ $t("admin") }}
        </h4>
        <strong class="text-xl">{{ totAdmin }}</strong>
      </div> -->
      <div v-if="totUser">
        <h4 class="text-sm uppercase text-white/75">
          {{ $t("users") }}
        </h4>
        <strong class="text-xl">{{ totUser }}</strong>
      </div>
      <div>
        <h4 class="text-sm uppercase text-white/75">
          {{ `${$t("channel")} ${$t("usage")}` }}
        </h4>
        <strong class="text-xl">{{ totalChannelUsage }}</strong>
      </div>
      <div>
        <h4 class="text-sm uppercase text-white/75">
          {{ `${$t("scopes")} ${$t("usage")}` }}
        </h4>
        <strong class="text-xl">{{ totalIntentAndCoreUsage }}</strong>
      </div>
    </div>
  </BaseBoxColor>
</template>

<script setup>
import { markRaw } from "vue";
import useModalStore from "@/stores/modal";
import useAuthStore from "@/stores/auth";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import OrganizationForm from "@/components/organizations/OrganizationForm.vue";
import OrganizationOverview from "./OrganizationOverview.vue";

const modal = useModalStore();
const { user } = storeToRefs(useAuthStore());
const { t } = useI18n();

function handleOverviewOrganization(organization) {
  modal.openModal({
    title: `${t("overview")} - ${organization.name}`,
    component: markRaw(OrganizationOverview),
    props: {
      organizationSlug: organization.slug,
    },
    customClass: "w-[60rem] max-w-[60rem] min-w-[40rem]"
  });
}
function handleManageOrganization(organization) {
  modal.openModal({
    title: t("manageOrganization"),
    component: markRaw(OrganizationForm),
    props: {
      organizationId: organization.id,
      organizationName: organization.name,
      organizationAuthenticationEndpoint: organization.authenticationEndpoint,
      organizationConfiguration: organization.configuration
    },
    customClass: "w-[40rem] max-w-[40rem] "
  });
}

defineProps({
  name: {
    type: String,
    required: true,
  },
  code: {
    type: String,
    required: true,
  },
  scopebase: {
    type: String,
    required: true,
  },
  activeScopes: {
    type: Array,
  },
  debugScopes: {
    type: Array,
  },
  totAdmin: {
    type: Number,
  },
  totUser: {
    type: Number,
  },
  totalChannelUsage :{
    type: Number,
  },
  totalIntentAndCoreUsage :{
    type: Number,
  },
  organization: {
    type: Object,
    required: false
  }
});
</script>
